import { Button, mergeClasses } from "@fluentui/react-components";
import { AppButtonProps } from "./AppButton.types";
import { useAppButtonStyles } from "./AppButton.styles";

export function AppButton({
  variant = "filled",
  color = "brand",
  size = "md",
  shape = "square",
  type = "button",
  className,
  children,
  onClick,
  disabled = false,
  ...fluentProps
}: AppButtonProps) {
  const styles = useAppButtonStyles();
  const styleKey = `${color}${variant[0].toUpperCase() + variant.slice(1)}`;

  const combinedClasses = mergeClasses(
    styles.root,
    styles[styleKey],
    styles[size],
    className
  );

  return (
    <Button
      as="button"
      appearance="transparent"
      shape={shape}
      type={type}
      disabled={disabled}
      className={combinedClasses}
      onClick={onClick}
      {...fluentProps}
    >
      {children}
    </Button>
  );
}
